export default [
  {
    //  审判从神家起首工作开始的六个试炼
    path: "/six-trials-of-God-s-judgment-work",
    name: "six-trials-of-God-s-judgment-work",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/index.vue"
      ),
    meta: {
      title: "审判从神家起首工作开始的六个试炼",
      order: 5,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/index/six-trials-of-God-s-judgment-work-bg-1.jpg",
        ],
      },
    },
  },
  {
    //  效力者的试炼
    path: "/six-trials-of-God-s-judgment-work/the-trial-of-service-doers",
    name: "the-trial-of-service-doers",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/index.vue"
      ),
    meta: {
      title: "效力者的试炼",
      order: 6,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/the-trial-of-service-doers/page2ImageViewer.jpg",
        ],
      },
    },
  },
  {
    //  死的试炼
    path: "/six-trials-of-God-s-judgment-work/the-trial-of-death",
    name: "the-trial-of-death",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/the-trial-of-death/index.vue"
      ),
    meta: {
      title: "死的试炼",
      order: 7,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/the-trial-of-death/page1ImageViewer.jpg",
        ],
      },
    },
  },
  {
    //  爱神时代
    path: "/six-trials-of-God-s-judgment-work/the-time-of-loving-God",
    name: "the-time-of-loving-God",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/the-time-of-loving-God/index.vue"
      ),
    meta: {
      title: "爱神时代",
      order: 8,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/the-time-of-loving-God/page1ImageViewer.jpg",
        ],
      },
    },
  },
  {
    //  衬托物的试炼
    path: "/six-trials-of-God-s-judgment-work/the-trial-of-foils",
    name: "the-trial-of-foils",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/the-trial-of-foils/index.vue"
      ),
    meta: {
      title: "衬托物的试炼",
      order: 9,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [],
      },
    },
  },
  {
    //  摩押后代的试炼
    path: "/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab",
    name: "trial-of-descendants-of-moab",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/index.vue"
      ),
    meta: {
      title: "摩押后代的试炼",
      order: 10,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/trial-of-descendants-of-moab/page1ImageViewer.jpg",
        ],
      },
    },
  },
  {
    //  大红龙子孙的试炼
    path: "/six-trials-of-God-s-judgment-work/trial-of-great-red-dragon-s-offspring",
    name: "trial-of-great-red-dragon-s-offspring",
    component: () =>
      import(
        "@/views/six-trials-of-God-s-judgment-work/trial-of-great-red-dragon-s-offspring/index.vue"
      ),
    meta: {
      title: "大红龙子孙的试炼",
      order: 11,
      episode: "episode3",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/six-trials-of-God-s-judgment-work/trial-of-great-red-dragon-s-offspring/page1ImageViewer.jpg",
        ],
      },
    },
  },
];
